<template>
<div class="chapter">
<div class="inner_page">
<div class="bglgry">
<div class="tspace">
<div class="img_container"><a id="page_5"><img alt="image" class="bwht" src="images/img-006.jpg"/></a></div><a id="page_5">
</a></div><a id="page_5">
<h1 class="fmtitle1" id="con">Contents</h1>
</a><p class="toc"><a id="page_5"></a><a href="#/xhtml/08_Chapter01#ch1"><span class="ash">1</span> Introduction</a></p>
<p class="toc"><a href="#/xhtml/09_Chapter02#ch2"><span class="ash">2</span> Motivation &amp; inspiration</a></p>
<p class="toc"><span href="#/xhtml/10_Chapter03#ch3" title="Link target outside of Sample"><span class="ash">3</span> What you need</span></p>
<p class="toc"><span href="#/xhtml/11_Chapter04#ch4" title="Link target outside of Sample"><span class="ash">4</span> Sketching techniques</span></p>
<p class="toc"><span href="#/xhtml/12_Chapter05#ch5" title="Link target outside of Sample"><span class="ash">5</span> Composition</span></p>
<p class="toc"><span href="#/xhtml/13_Chapter06#ch6" title="Link target outside of Sample"><span class="ash">6</span> Value &amp; colour</span></p>
<p class="toc"><span href="#/xhtml/14_Chapter07#ch7" title="Link target outside of Sample"><span class="ash">7</span> People indoors</span></p>
<p class="toca"><span href="#/xhtml/14_Chapter07#ch7a" title="Link target outside of Sample">PUB SCENE</span></p>
<p class="toc"><span href="#/xhtml/15_Chapter08#ch8" title="Link target outside of Sample"><span class="ash">8</span> People outdoors</span></p>
<p class="toca"><span href="#/xhtml/15_Chapter08#ch8a" title="Link target outside of Sample">BUSKER</span></p>
<p class="toc"><span href="#/xhtml/16_Chapter09#ch9" title="Link target outside of Sample"><span class="ash">9</span> Places outdoors</span></p>
<p class="toca"><span href="#/xhtml/16_Chapter09#ch9a" title="Link target outside of Sample">STATUE</span></p>
<p class="toc"><span href="#/xhtml/17_Chapter10#ch10" title="Link target outside of Sample"><span class="ash">10</span> Places indoors</span></p>
<p class="toca"><span href="#/xhtml/17_Chapter10#ch10a" title="Link target outside of Sample">GALLERY</span></p>
<p class="toc"><span href="#/xhtml/18_Chapter11#ch11" title="Link target outside of Sample"><span class="ash">11</span> Discouer</span></p>
<p class="toc"><span href="#/xhtml/19_Chapter12#ch12" title="Link target outside of Sample"><span class="ash">12</span> Painting</span></p>
<p class="toct"><span href="#/xhtml/20_Index#ind" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Contents.vue?1191f974